import React from 'react';
import { LoadingWrap } from './style';

const SearchLoading = () => {
    return <LoadingWrap>Loading...</LoadingWrap>;
};

export default SearchLoading;



// WEBPACK FOOTER //
// ./src/UI/Containers/Search/SearchLoading.js